module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-categories-dialog":"Angeforderte Dateien (Kategorien)"},"fr":{"title-categories-dialog":"Fichiers demandés (catégories)"},"it":{"title-categories-dialog":"File richiesti (categorie)"}}')
  delete Component.options._Ctor
}
